import React, { useEffect, useState } from 'react';
import NavLogo from '../../components/NavLogo';
import Logo from '../../components/Logo';
import HeaderBanner from '../../layouts/HeaderBanner';
import * as yup from 'yup';
import { useDispatch, useSelector } from 'react-redux';
import { Link, useNavigate, useParams } from 'react-router-dom';
import { getCurrentAccount, getEntities, getEntityProfileList, registerNewMember, retrieveEntityWarehouseReceiptList, retrieveEntityWarehouseReceiptListReset } from '../../utils/actions';
import * as app_consts from '../../utils/constants';
import { addThreeDots, capitalizeSentences } from '../../utils/functionalUtils';
import TableComp from '../../components/table/TableComp';
import CustomTabs from '../../layouts/CustomTabs';

const WarehouseReceipts = () => {

    const { entity_id, entity_mid, view } = useParams();
    const [spectator_role_check, setRoleCheck] = useState(false);

    // Retrieve Account from Local Storage
    const account = localStorage.getItem('account') ? JSON.parse(localStorage.getItem('account')) : {};
    // Get Warehouse Operator from Account
    const warehouseOperatorProfile = account?.profiles.find(profile => profile.type === app_consts.WAREHOUSE_OPERATOR.toLowerCase() && profile.entity_id === entity_id);

    useEffect(() => {
    if (warehouseOperatorProfile) {
      setRoleCheck(warehouseOperatorProfile?.roles?.includes("spectator"));
    }
    }, [warehouseOperatorProfile]); 

    const currentUrl = window.location.href;

    const dispatch = useDispatch();
    const navigate = useNavigate();
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState("");
    const fetchedTotalEntities = useSelector(state => state.entityList.total);
    const [totalEntities, setTotalEntities] = useState(fetchedTotalEntities);
    const [searchTerm, setSearchTerm] = useState("");
    const [currentPage, setCurrentPage] = useState(1);
    const pageSize = 20;
    const [warehouseReceiptList, setWarehouseReceiptList] = useState([]);
    const [warehouseReceiptListData, setWarehouseReceiptListData] = useState([]);
    const [totalWarehouseReceipt, setTotalWarehouseReceipts] = useState(0);
    const [openDropDown, setOpenDropdown] = useState(false);
    const [isDataFetched, setIsDataFetched] = useState(false);
    const [activeTab, setActiveTab] = useState('Own Warehouse Receipts');

    const [own_warehouse_receipt_list, setOwnWarehouseReceiptList] = useState([]);
    const [own_warehouse_receipt_list_data, setOwnWarehouseReceiptListData] = useState([]);
    const [client_warehouse_receipt_list, setClientWarehouseReceiptList] = useState([]);
    const [client_warehouse_receipt_list_data, setClientWarehouseReceiptListData] = useState([]);
    const [bulk_delivery_check, setBulkDeliveryCheck] = useState(false);

    const [profilesList, setProfilesList] = useState([]);


    // Retrieve Warehouse List On Page Load
    useEffect(() => {
        fetchWarehouseReceipts();
        fetchProfileList();
        dispatch(getCurrentAccount());

        if (warehouseOperatorProfile)
        {
            setBulkDeliveryCheck(warehouseOperatorProfile?.roles?.includes(app_consts.BULK_DELIVERY_PROCESSING.toLowerCase()));
        }
    }, []);

    const fetchWarehouseReceipts = async () => {
        try
        {
            await dispatch(retrieveEntityWarehouseReceiptList(entity_mid));
        } catch (error)
        {
            console.error(error);
        }
    };

    // Fetech Profile List
    const fetchProfileList = async () => {
        try
        {
            dispatch(getEntityProfileList(entity_id));
        } catch (error)
        {
            console.error(error);
        }
    };

    // Listen to Changes When Fetching Warehouse Recipt List
    const warehouseReceiptListListener = useSelector((state) => state.retrieveEntityWarehouseReceiptList);

    useEffect(() => {
        if (warehouseReceiptListListener.status !== app_consts.IDLE)
        {
            if (warehouseReceiptListListener.isLoading)
            {
                setLoading(true);
            }
            else
            {
                if (warehouseReceiptListListener.error)
                {
                    setError(warehouseReceiptListListener.error);
                }
                else if (warehouseReceiptListListener.data)
                {
                    setIsDataFetched(true);
                    setWarehouseReceiptListData(warehouseReceiptListListener.data);
                    setWarehouseReceiptList(warehouseReceiptListListener.data);
                    setTotalWarehouseReceipts(warehouseReceiptListListener?.data?.length);
                }
                dispatch(retrieveEntityWarehouseReceiptListReset());
                setLoading(false);
            }
        }
    }, [warehouseReceiptListListener]);

    // UseEffect to Split Total Warehouse Receipt Data
    useEffect(() => {
        if (warehouseReceiptList)
        {
            const own_warehouse_receipt = warehouseReceiptList?.filter((receipt) => app_consts.WAREHOUSE_OPERATOR.toLowerCase() === receipt?.depositor_type && receipt?.entity_id === entity_id || app_consts.BROKER.toLowerCase() === receipt?.depositor_type);

            const client_warehouse_receipt = warehouseReceiptList?.filter((receipt) => app_consts.WAREHOUSE_OPERATOR.toLowerCase() !== receipt?.depositor_type && app_consts.BROKER.toLowerCase() !== receipt?.depositor_type);

            setOwnWarehouseReceiptList(own_warehouse_receipt);
            setOwnWarehouseReceiptListData(own_warehouse_receipt);
            setClientWarehouseReceiptList(client_warehouse_receipt);
            setClientWarehouseReceiptListData(client_warehouse_receipt);
        }
    }, [warehouseReceiptList]);

    // Retrieve Profile List from State
    const profile_list = useSelector((state) => state.entityProfilesList);

    useEffect(() => {
        if (profile_list.data) 
        {
            const selectedlist = profile_list.data?.find((profile) => profile.member_type_id === entity_mid);
            setProfilesList(selectedlist);
        }
    }, [profile_list]);

    // Calculate the start and end index for the current page
    const startIndex = (currentPage - 1) * pageSize;
    const endIndex = startIndex + pageSize;


    const filteredWarehouseReceipts = (searchItem) => {
        if (searchItem)
        {
            let displayedWarehouseReceipts;

            if (activeTab === "Own Warehouse Receipts") 
            {
                displayedWarehouseReceipts = own_warehouse_receipt_list_data?.filter((receipt) => {
                    const combinedParams = [
                        receipt.receipt_number,
                        receipt.owner_name,
                        receipt.quantity,
                        receipt.commodity?.replace(/_/g, ' ').toUpperCase(),
                        receipt.status?.replace(/_/g, ' ').toUpperCase(),
                    ].join(" ").toLowerCase();

                    return combinedParams.includes(searchItem.toLowerCase());
                }).slice(startIndex, endIndex);

                setOwnWarehouseReceiptList(displayedWarehouseReceipts || []);

            }
            else if (activeTab === "Client Warehouse Receipts") 
            {
                displayedWarehouseReceipts = client_warehouse_receipt_list_data?.filter((receipt) => {
                    const combinedParams = [
                        receipt.receipt_number,
                        receipt.owner_name,
                        receipt.quantity,
                        receipt.commodity?.replace(/_/g, ' ').toUpperCase(),
                        receipt.status?.replace(/_/g, ' ').toUpperCase(),
                    ].join(" ").toLowerCase();

                    return combinedParams.includes(searchItem.toLowerCase());
                }).slice(startIndex, endIndex);


                setClientWarehouseReceiptList(displayedWarehouseReceipts || []);
            }
        }
        else
        {
            setWarehouseReceiptList(warehouseReceiptListData);
        }
    };

    // UseEffect for Active Tab Change
    useEffect(() => {
        setWarehouseReceiptListData(warehouseReceiptListData);
        setSearchTerm("");
    }, [activeTab]);


    // UseEffect for Search 
    useEffect(() => {
        filteredWarehouseReceipts(searchTerm);
    }, [searchTerm]);

    // Handle Logout
    const handleLogout = () => {
        localStorage.clear();
        navigate("/");
    };

    // Get current items based on pagination
    const indexOfLastItem = currentPage * pageSize;
    const indexOfFirstItem = indexOfLastItem - pageSize;
    const currentItems = warehouseReceiptList?.slice(indexOfFirstItem, indexOfLastItem);

    // URL Prefixes
    const warehouseUrlPrefix = () => {
        if (view)
        {
            return 'warehouse/view';
        }
        else
        {
            return 'warehouse';
        }
    };

    const tabs = [
        { title: 'Own Warehouse Receipts', disabled: !isDataFetched },
        { title: 'Client Warehouse Receipts', disabled: !isDataFetched },
    ];

    return (
        <>
            <button data-drawer-target="logo-sidebar" data-drawer-toggle="logo-sidebar" aria-controls="logo-sidebar" type="button" className="inline-flex items-center p-2 mt-2 ml-3 text-sm text-gray-500 rounded-lg sm:hidden hover:bg-gray-100 focus:outline-none focus:ring-2 focus:ring-gray-200 dark:text-gray-400 dark:hover:bg-gray-700 dark:focus:ring-gray-600">
                <span className="sr-only">Open sidebar</span>
                <svg className="w-6 h-6" aria-hidden="true" fill="currentColor" viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg">
                    <path clip-rule="evenodd" fill-rule="evenodd" d="M2 4.75A.75.75 0 012.75 4h14.5a.75.75 0 010 1.5H2.75A.75.75 0 012 4.75zm0 10.5a.75.75 0 01.75-.75h7.5a.75.75 0 010 1.5h-7.5a.75.75 0 01-.75-.75zM2 10a.75.75 0 01.75-.75h14.5a.75.75 0 010 1.5H2.75A.75.75 0 012 10z"></path>
                </svg>
                <NavLogo />
            </button>

            <aside id="logo-sidebar" className="fixed top-0 left-0 z-40 w-64 h-screen transition-transform -translate-x-full sm:translate-x-0" aria-label="Sidebar">
                <div className="h-full px-3 py-4 overflow-y-auto bg-gray-50 dark:bg-gray-800">
                    <a href="/" className="flex items-center pl-2.5 mb-5">
                        <Logo /></a>

                    <ul className="space-y-2 font-medium relative">
                        <li>
                            <a href="/home" className="flex items-center p-2 text-gray-600 hover:text-green-600 rounded-lg dark:text-white hover:bg-gray-100 dark:hover:bg-gray-700 group">
                                <svg class="w-6 h-6 dark:text-white" aria-hidden="true" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 18 18">
                                    <path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M6.143 1H1.857A.857.857 0 0 0 1 1.857v4.286c0 .473.384.857.857.857h4.286A.857.857 0 0 0 7 6.143V1.857A.857.857 0 0 0 6.143 1Zm10 0h-4.286a.857.857 0 0 0-.857.857v4.286c0 .473.384.857.857.857h4.286A.857.857 0 0 0 17 6.143V1.857A.857.857 0 0 0 16.143 1Zm-10 10H1.857a.857.857 0 0 0-.857.857v4.286c0 .473.384.857.857.857h4.286A.857.857 0 0 0 7 16.143v-4.286A.857.857 0 0 0 6.143 11Zm10 0h-4.286a.857.857 0 0 0-.857.857v4.286c0 .473.384.857.857.857h4.286a.857.857 0 0 0 .857-.857v-4.286a.857.857 0 0 0-.857-.857Z" />
                                </svg>
                                <span className="ml-3">My Dashboards</span>
                            </a>
                        </li>
                        <li>
                            <a href={`/${warehouseUrlPrefix()}/${entity_id}/${entity_mid}`} className="flex items-center p-2 text-gray-600 hover:text-green-600 rounded-lg dark:text-white hover:bg-gray-100 dark:hover:bg-gray-700 group">
                                <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" class="w-6 h-6">
                                    <path stroke-linecap="round" stroke-linejoin="round" d="M12 21v-8.25M15.75 21v-8.25M8.25 21v-8.25M3 9l9-6 9 6m-1.5 12V10.332A48.36 48.36 0 0012 9.75c-2.551 0-5.056.2-7.5.582V21M3 21h18M12 6.75h.008v.008H12V6.75z" />
                                </svg>


                                <span className="ml-3">Warehouse Dashboard</span>
                            </a>
                        </li>
                        <li>
                            <a href={`/${warehouseUrlPrefix()}/${entity_id}/${entity_mid}/locations`} className="flex items-center p-2 text-gray-600 hover:text-green-600 rounded-lg dark:text-white hover:bg-gray-100 dark:hover:bg-gray-700 group">
                                <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={1.5} stroke="currentColor" className="w-6 h-6">
                                    <path strokeLinecap="round" strokeLinejoin="round" d="M15 10.5a3 3 0 11-6 0 3 3 0 016 0z" />
                                    <path strokeLinecap="round" strokeLinejoin="round" d="M19.5 10.5c0 7.142-7.5 11.25-7.5 11.25S4.5 17.642 4.5 10.5a7.5 7.5 0 1115 0z" />
                                </svg>
                                <span className="ml-3">Warehouse Locations</span>
                            </a>
                        </li>
                        {/* <li>
                            <a className="cursor-not-allowed flex items-center p-2 text-gray-400 rounded-lg dark:text-white hover:bg-gray-100 dark:hover:bg-gray-700 group">
                            <a href={`/${warehouseUrlPrefix()}/${entity_id}/${entity_mid}/storage`} className="flex items-center p-2 text-gray-600 hover:text-green-600 rounded-lg dark:text-white hover:bg-gray-100 dark:hover:bg-gray-700 group">
                                <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={1.5} stroke="currentColor" className="w-6 h-6">
                                    <path strokeLinecap="round" strokeLinejoin="round" d="M20.25 6.375c0 2.278-3.694 4.125-8.25 4.125S3.75 8.653 3.75 6.375m16.5 0c0-2.278-3.694-4.125-8.25-4.125S3.75 4.097 3.75 6.375m16.5 0v11.25c0 2.278-3.694 4.125-8.25 4.125s-8.25-1.847-8.25-4.125V6.375m16.5 0v3.75m-16.5-3.75v3.75m16.5 0v3.75C20.25 16.153 16.556 18 12 18s-8.25-1.847-8.25-4.125v-3.75m16.5 0c0 2.278-3.694 4.125-8.25 4.125s-8.25-1.847-8.25-4.125" />
                                </svg>
                                <span className="ml-3">Warehouse Storage</span>
                            </a>
                        </li> */}
                        <li>
                            <a href={`/${warehouseUrlPrefix()}/${entity_id}/${entity_mid}/inbound_shipments`} className="flex items-center p-2 text-gray-600 hover:text-green-600 rounded-lg dark:text-white hover:bg-gray-100 dark:hover:bg-gray-700 group">

                                <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={1.5} stroke="currentColor" className="w-6 h-6">
                                    <path strokeLinecap="round" strokeLinejoin="round" d="M7.5 21L3 16.5m0 0L7.5 12M3 16.5h13.5m0-13.5L21 7.5m0 0L16.5 12M21 7.5H7.5" />
                                </svg>
                                <span className="ml-3">Inbound Shipments</span>
                            </a>
                        </li>
                        <li>
                            <a href={`/${warehouseUrlPrefix()}/${entity_id}/${entity_mid}/receipts`} className="flex bg-white text-green-600  items-center p-2 text-gray-900 rounded-lg dark:text-white hover:bg-gray-100 dark:hover:bg-gray-700 group">
                                <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={1.5} stroke="currentColor" className="w-6 h-6">
                                    <path strokeLinecap="round" strokeLinejoin="round" d="M9 14.25l6-6m4.5-3.493V21.75l-3.75-1.5-3.75 1.5-3.75-1.5-3.75 1.5V4.757c0-1.108.806-2.057 1.907-2.185a48.507 48.507 0 0111.186 0c1.1.128 1.907 1.077 1.907 2.185zM9.75 9h.008v.008H9.75V9zm.375 0a.375.375 0 11-.75 0 .375.375 0 01.75 0zm4.125 4.5h.008v.008h-.008V13.5zm.375 0a.375.375 0 11-.75 0 .375.375 0 01.75 0z" />
                                </svg>

                                <span className="ml-3">Warehouse Receipts</span>
                            </a>
                        </li>
                        <li>
                            {/* <a className="cursor-not-allowed flex items-center p-2 text-gray-400 rounded-lg dark:text-white hover:bg-gray-100 dark:hover:bg-gray-700 group"> */}
                            <a href={`/${warehouseUrlPrefix()}/${entity_id}/${entity_mid}/receipt_depositors`} className="flex items-center p-2 text-gray-600 hover:text-green-600 rounded-lg dark:text-white hover:bg-gray-100 dark:hover:bg-gray-700 group">
                                <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" class="w-6 h-6">
                                    <path stroke-linecap="round" stroke-linejoin="round" d="M18 18.72a9.094 9.094 0 0 0 3.741-.479 3 3 0 0 0-4.682-2.72m.94 3.198.001.031c0 .225-.012.447-.037.666A11.944 11.944 0 0 1 12 21c-2.17 0-4.207-.576-5.963-1.584A6.062 6.062 0 0 1 6 18.719m12 0a5.971 5.971 0 0 0-.941-3.197m0 0A5.995 5.995 0 0 0 12 12.75a5.995 5.995 0 0 0-5.058 2.772m0 0a3 3 0 0 0-4.681 2.72 8.986 8.986 0 0 0 3.74.477m.94-3.197a5.971 5.971 0 0 0-.94 3.197M15 6.75a3 3 0 1 1-6 0 3 3 0 0 1 6 0Zm6 3a2.25 2.25 0 1 1-4.5 0 2.25 2.25 0 0 1 4.5 0Zm-13.5 0a2.25 2.25 0 1 1-4.5 0 2.25 2.25 0 0 1 4.5 0Z" />
                                </svg>
                                <span className="ml-3">WHR Depositors</span>
                            </a>
                        </li>
                        <li>
                            <a href={`/${warehouseUrlPrefix()}/${entity_id}/${entity_mid}/trade_fulfillments`} className="flex items-center p-2 text-gray-600 hover:text-green-600 rounded-lg dark:text-white hover:bg-gray-100 dark:hover:bg-gray-700 group">
                                <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" class="w-6 h-6">
                                    <path stroke-linecap="round" stroke-linejoin="round" d="M11.35 3.836c-.065.21-.1.433-.1.664 0 .414.336.75.75.75h4.5a.75.75 0 0 0 .75-.75 2.25 2.25 0 0 0-.1-.664m-5.8 0A2.251 2.251 0 0 1 13.5 2.25H15c1.012 0 1.867.668 2.15 1.586m-5.8 0c-.376.023-.75.05-1.124.08C9.095 4.01 8.25 4.973 8.25 6.108V8.25m8.9-4.414c.376.023.75.05 1.124.08 1.131.094 1.976 1.057 1.976 2.192V16.5A2.25 2.25 0 0 1 18 18.75h-2.25m-7.5-10.5H4.875c-.621 0-1.125.504-1.125 1.125v11.25c0 .621.504 1.125 1.125 1.125h9.75c.621 0 1.125-.504 1.125-1.125V18.75m-7.5-10.5h6.375c.621 0 1.125.504 1.125 1.125v9.375m-8.25-3 1.5 1.5 3-3.75" />
                                </svg>

                                <span className="ml-3">Trade Fulfillments</span>
                            </a>
                        </li>
                        <li>
                            <a href={`/${warehouseUrlPrefix()}/${entity_id}/${entity_mid}/reports`} className="flex items-center p-2 text-gray-600 hover:text-green-600 rounded-lg dark:text-white hover:bg-gray-100 dark:hover:bg-gray-700 group">
                                <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={1.5} stroke="currentColor" className="w-6 h-6">
                                    <path strokeLinecap="round" strokeLinejoin="round" d="M7.5 14.25v2.25m3-4.5v4.5m3-6.75v6.75m3-9v9M6 20.25h12A2.25 2.25 0 0020.25 18V6A2.25 2.25 0 0018 3.75H6A2.25 2.25 0 003.75 6v12A2.25 2.25 0 006 20.25z" />
                                </svg>

                                <span className="ml-3">Warehouse Reports</span>
                            </a>
                        </li>
                        <li>
                            <a href={`/${warehouseUrlPrefix()}/${entity_id}/${entity_mid}/profile`} className="flex items-center p-2 text-gray-600 hover:text-green-600 rounded-lg dark:text-white hover:bg-gray-100 dark:hover:bg-gray-700 group">
                                <svg class="w-6 h-6 dark:text-white" aria-hidden="true" viewBox="0 0 20 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <path d="M6.5 8C5.80777 8 5.13108 7.79473 4.55551 7.41015C3.97993 7.02556 3.53133 6.47893 3.26642 5.83939C3.00152 5.19985 2.9322 4.49612 3.06725 3.81719C3.2023 3.13825 3.53564 2.51461 4.02513 2.02513C4.51461 1.53564 5.13825 1.2023 5.81719 1.06725C6.49612 0.932205 7.19985 1.00152 7.83939 1.26642C8.47893 1.53133 9.02556 1.97993 9.41015 2.55551C9.79473 3.13108 10 3.80777 10 4.5" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
                                    <path d="M6.5 17H1V15C1 13.9391 1.42143 12.9217 2.17157 12.1716C2.92172 11.4214 3.93913 11 5 11" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
                                    <path d="M19.5 11H18.38C18.2672 10.5081 18.0714 10.0391 17.801 9.613L18.601 8.818C18.6947 8.72424 18.7474 8.59708 18.7474 8.4645C18.7474 8.33192 18.6947 8.20476 18.601 8.111L17.894 7.404C17.8002 7.31026 17.6731 7.25761 17.5405 7.25761C17.4079 7.25761 17.2808 7.31026 17.187 7.404L16.392 8.204C15.9647 7.93136 15.4939 7.73384 15 7.62V6.5C15 6.36739 14.9473 6.24021 14.8536 6.14645C14.7598 6.05268 14.6326 6 14.5 6H13.5C13.3674 6 13.2402 6.05268 13.1464 6.14645C13.0527 6.24021 13 6.36739 13 6.5V7.62C12.5081 7.73283 12.0391 7.92863 11.613 8.199L10.818 7.404C10.7242 7.31026 10.5971 7.25761 10.4645 7.25761C10.3319 7.25761 10.2048 7.31026 10.111 7.404L9.404 8.111C9.31026 8.20476 9.25761 8.33192 9.25761 8.4645C9.25761 8.59708 9.31026 8.72424 9.404 8.818L10.204 9.618C9.9324 10.0422 9.73492 10.5096 9.62 11H8.5C8.36739 11 8.24021 11.0527 8.14645 11.1464C8.05268 11.2402 8 11.3674 8 11.5V12.5C8 12.6326 8.05268 12.7598 8.14645 12.8536C8.24021 12.9473 8.36739 13 8.5 13H9.62C9.73283 13.4919 9.92863 13.9609 10.199 14.387L9.404 15.182C9.31026 15.2758 9.25761 15.4029 9.25761 15.5355C9.25761 15.6681 9.31026 15.7952 9.404 15.889L10.111 16.596C10.2048 16.6897 10.3319 16.7424 10.4645 16.7424C10.5971 16.7424 10.7242 16.6897 10.818 16.596L11.618 15.796C12.0422 16.0676 12.5096 16.2651 13 16.38V17.5C13 17.6326 13.0527 17.7598 13.1464 17.8536C13.2402 17.9473 13.3674 18 13.5 18H14.5C14.6326 18 14.7598 17.9473 14.8536 17.8536C14.9473 17.7598 15 17.6326 15 17.5V16.38C15.4919 16.2672 15.9609 16.0714 16.387 15.801L17.182 16.601C17.2758 16.6947 17.4029 16.7474 17.5355 16.7474C17.6681 16.7474 17.7952 16.6947 17.889 16.601L18.596 15.894C18.6897 15.8002 18.7424 15.6731 18.7424 15.5405C18.7424 15.4079 18.6897 15.2808 18.596 15.187L17.796 14.392C18.0686 13.9647 18.2662 13.4939 18.38 13H19.5C19.6326 13 19.7598 12.9473 19.8536 12.8536C19.9473 12.7598 20 12.6326 20 12.5V11.5C20 11.3674 19.9473 11.2402 19.8536 11.1464C19.7598 11.0527 19.6326 11 19.5 11ZM14 14.5C13.5055 14.5 13.0222 14.3534 12.6111 14.0787C12.2 13.804 11.8795 13.4135 11.6903 12.9567C11.5011 12.4999 11.4516 11.9972 11.548 11.5123C11.6445 11.0273 11.8826 10.5819 12.2322 10.2322C12.5819 9.8826 13.0273 9.6445 13.5123 9.54804C13.9972 9.45157 14.4999 9.50108 14.9567 9.6903C15.4135 9.87952 15.804 10.2 16.0787 10.6111C16.3534 11.0222 16.5 11.5055 16.5 12C16.5 12.663 16.2366 13.2989 15.7678 13.7678C15.2989 14.2366 14.663 14.5 14 14.5Z" fill="currentColor" />
                                </svg>

                                <span className="flex-1 ml-3 whitespace-nowrap">Profile</span>
                            </a>
                        </li>
                        <li className="my-2 fixed bottom-12 w-11/12">
                            <a onClick={handleLogout} className="cursor-pointer flex items-center p-2 text-gray-600 hover:text-green-600 rounded-lg dark:text-white hover:bg-gray-100 dark:hover:bg-gray-700 group">
                                <svg class="w-6 h-6 dark:text-white" aria-hidden="true" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 16 16">
                                    <path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M4 8h11m0 0-4-4m4 4-4 4m-5 3H3a2 2 0 0 1-2-2V3a2 2 0 0 1 2-2h3" />
                                </svg>
                                <span className="flex-1 ml-3 whitespace-nowrap">Sign Out</span>
                            </a>
                        </li>
                    </ul>
                </div>
            </aside>

            <div className="p-4 sm:ml-64">
                <div className="p-4 rounded-lg dark:border-gray-700">
                    <HeaderBanner title="Warehouse Receipts" header_addition={profilesList && profilesList.entity_name ? profilesList.entity_name : ""} home={`${warehouseUrlPrefix()}/${entity_id}/${entity_mid}`} type={app_consts.WAREHOUSE_RECEIPTS} navInfo={{ entity_id, entity_mid }} />
                    <div class="w-full relative bg-white dark:bg-gray-800 sm:rounded-lg">
                        <div class="flex flex-col items-center justify-between p-4 space-y-3 md:flex-row md:space-y-0 md:space-x-4">
                            <div class="w-full md:w-1/2">
                                <form class="flex items-center">
                                    <label for="simple-search" class="sr-only">Search</label>
                                    <div class="relative w-full">
                                        <div class="absolute inset-y-0 left-0 flex items-center pl-3 pointer-events-none">
                                            <svg aria-hidden="true" class="w-5 h-5 text-gray-500 dark:text-gray-400" fill="currentColor" viewbox="0 0 20 20" xmlns="http://www.w3.org/2000/svg">
                                                <path fill-rule="evenodd" d="M8 4a4 4 0 100 8 4 4 0 000-8zM2 8a6 6 0 1110.89 3.476l4.817 4.817a1 1 0 01-1.414 1.414l-4.816-4.816A6 6 0 012 8z" clip-rule="evenodd" />
                                            </svg>
                                        </div>
                                        <input value={searchTerm} onChange={e => setSearchTerm(e.target.value)} type="text" id="simple-search" class="block w-full p-2 pl-10 text-sm text-gray-900 border border-gray-300 rounded-lg bg-gray-50 focus:ring-primary-500 focus:border-primary-500 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-primary-500 dark:focus:border-primary-500" placeholder="Search" required="" />
                                    </div>
                                </form>
                            </div>
                            <div class="flex flex-col items-stretch justify-end flex-shrink-0 w-full space-y-2 md:w-auto md:flex-row md:space-y-0 md:items-center md:space-x-3">
                                {
                                    !spectator_role_check && !view && (
                                        <>
                                            <div className='relative flex flex-column'>
                                                <button className="flex items-center justify-center px-4 py-2 text-sm font-medium text-white rounded-lg bg-primary-700 hover:bg-primary-800 focus:ring-4 focus:ring-primary-300 dark:bg-primary-600 dark:hover:bg-primary-700 focus:outline-none dark:focus:ring-primary-800" type="button" onClick={() => setOpenDropdown(!openDropDown)}>
                                                    <svg
                                                        xmlns="http://www.w3.org/2000/svg"
                                                        viewBox="0 0 20 20"
                                                        fill="currentColor"
                                                        className="w-5 h-5 mr-2"
                                                    >
                                                        <path d="M5.433 13.917l1.262-3.155A4 4 0 017.58 9.42l6.92-6.918a2.121 2.121 0 013 3l-6.92 6.918c-.383.383-.84.685-1.343.886l-3.154 1.262a.5.5 0 01-.65-.65z" />
                                                        <path d="M3.5 5.75c0-.69.56-1.25 1.25-1.25H10A.75.75 0 0010 3H4.75A2.75 2.75 0 002 5.75v9.5A2.75 2.75 0 004.75 18h9.5A2.75 2.75 0 0017 15.25V10a.75.75 0 00-1.5 0v5.25c0 .69-.56 1.25-1.25 1.25h-9.5c-.69 0-1.25-.56-1.25-1.25v-9.5z" />
                                                    </svg>
                                                    Process Warehouse Receipt
                                                </button>

                                                <div className={`z-10 ${openDropDown ? "absolute right-0 origin-top-right mt-12 right-6" : "hidden"} w-full bg-gray-100 divide-y divide-gray-100 rounded-lg shadow w-44 dark:bg-gray-700 border-1 border-gray-300`}>
                                                    <ul className=" border-1 font-bold border-gray-200 rounded-lg text-sm text-gray-800 dark:text-gray-200" aria-labelledby="multiLevelDropdownButton">
                                                        <li>
                                                            <span onClick={() => navigate(`/${warehouseUrlPrefix()}/${entity_id}/${entity_mid}/receipts/process`)} className="hover:bg-gray-300 cursor-pointer block px-4 py-4 dark:hover:bg-gray-600 dark:hover:text-white">Single Delivery (No GRN)</span>
                                                        </li>
                                                        {
                                                            bulk_delivery_check && (
                                                                <>
                                                                    <li>
                                                                        <span onClick={() => navigate(`/${warehouseUrlPrefix()}/${entity_id}/${entity_mid}/receipts/process_bulk`)} className="hover:bg-gray-300 cursor-pointer block px-4 py-4 hover:bg-gray-100 dark:hover:bg-gray-600 dark:hover:text-white">Bulk Delivery (No GRN)</span>
                                                                    </li>
                                                                </>
                                                            )
                                                        }
                                                        <li>
                                                            <span onClick={() => navigate(`/${warehouseUrlPrefix()}/${entity_id}/${entity_mid}/receipts/process_grn`)} className="hover:bg-gray-300 cursor-pointer block px-4 py-4 dark:hover:bg-gray-600 dark:hover:text-white">GRN Delivery</span>
                                                        </li>
                                                    </ul>
                                                </div>
                                            </div>
                                        </>
                                    )
                                }
                                {/* <div class="flex items-center w-full space-x-3 md:w-auto">
                                    <button id="actionsDropdownButton" data-dropdown-toggle="actionsDropdown" class="flex items-center justify-center w-full px-4 py-2 text-sm font-medium text-gray-900 bg-white border border-gray-200 rounded-lg md:w-auto focus:outline-none hover:bg-gray-100 hover:text-primary-700 focus:z-10 focus:ring-4 focus:ring-gray-200 dark:focus:ring-gray-700 dark:bg-gray-800 dark:text-gray-400 dark:border-gray-600 dark:hover:text-white dark:hover:bg-gray-700" type="button">
                                        <svg class="-ml-1 mr-1.5 w-5 h-5" fill="currentColor" viewbox="0 0 20 20" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
                                            <path clip-rule="evenodd" fill-rule="evenodd" d="M5.293 7.293a1 1 0 011.414 0L10 10.586l3.293-3.293a1 1 0 111.414 1.414l-4 4a1 1 0 01-1.414 0l-4-4a1 1 0 010-1.414z" />
                                        </svg>
                                        Actions
                                    </button>
                                    <div id="actionsDropdown" class="z-10 hidden bg-white divide-y divide-gray-100 rounded shadow w-44 dark:bg-gray-700 dark:divide-gray-600">
                                        <ul class="py-1 text-sm text-gray-700 dark:text-gray-200" aria-labelledby="actionsDropdownButton">
                                            <li>
                                                <a href="#" class="block px-4 py-2 hover:bg-gray-100 dark:hover:bg-gray-600 dark:hover:text-white">Mass Edit</a>
                                            </li>
                                        </ul>
                                        <div class="py-1">
                                            <a href="#" class="block px-4 py-2 text-sm text-gray-700 hover:bg-gray-100 dark:hover:bg-gray-600 dark:text-gray-200 dark:hover:text-white">Delete all</a>
                                        </div>
                                    </div>

                                </div> */}
                            </div>

                        </div>

                        <div className="relative">
                            <CustomTabs tabs={tabs} activeTab={activeTab} setActiveTab={setActiveTab} />
                            <br />
                            <div className="w-full text-sm text-left text-gray-500 dark:text-gray-400">
                                {
                                    <>
                                        {!loading && (
                                            <>
                                                {
                                                    error ?
                                                        <>
                                                            <tr className='flex items-center w-full justify-center'>
                                                                <td colSpan="8" className="w-full text-center py-4">
                                                                    <div role="status" className='text-red-600 flex flex-col items-center justify-center mb-4 leading-4'>
                                                                        <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={1.5} stroke="currentColor" className="w-8 h-8">
                                                                            <path strokeLinecap="round" strokeLinejoin="round" d="M9.75 9.75l4.5 4.5m0-4.5l-4.5 4.5M21 12a9 9 0 11-18 0 9 9 0 0118 0z" />
                                                                        </svg>
                                                                    </div>
                                                                    <span colSpan="8" className="text-gray-700 py-4 my-6 tracking-wider">
                                                                        {error}
                                                                    </span>
                                                                </td>
                                                            </tr>
                                                        </>
                                                        :
                                                        <>
                                                            {
                                                                activeTab === "Own Warehouse Receipts" && (
                                                                    <>
                                                                        <TableComp tableData={own_warehouse_receipt_list} tableType={app_consts.WAREHOUSE_RECEIPT_LIST_TABLE} tableHeading={activeTab} />
                                                                    </>
                                                                )
                                                            }
                                                            {
                                                                activeTab === "Client Warehouse Receipts" && (
                                                                    <>
                                                                        <TableComp tableData={client_warehouse_receipt_list} tableType={app_consts.WAREHOUSE_RECEIPT_LIST_TABLE} tableHeading={activeTab} />
                                                                    </>
                                                                )
                                                            }
                                                        </>
                                                }
                                            </>
                                        )
                                        }
                                    </>
                                }
                            </div>
                            {loading && (
                                <div className="text-center my-2">
                                    <div className="text-center my-6">
                                        <span colSpan="8" className="text-gray-700 py-4 my-2">
                                            Loading Warehouse Receipts...
                                        </span>
                                    </div>
                                    <div role="status">
                                        <svg
                                            aria-hidden="true"
                                            className="inline w-8 h-8 mr-2 text-gray-200 animate-spin dark:text-gray-600 fill-green-600"
                                            viewBox="0 0 100 101"
                                            fill="none"
                                            xmlns="http://www.w3.org/2000/svg"
                                        >
                                            <path
                                                d="M100 50.5908C100 78.2051 77.6142 100.591 50 100.591C22.3858 100.591 0 78.2051 0 50.5908C0 22.9766 22.3858 0.59082 50 0.59082C77.6142 0.59082 100 22.9766 100 50.5908ZM9.08144 50.5908C9.08144 73.1895 27.4013 91.5094 50 91.5094C72.5987 91.5094 90.9186 73.1895 90.9186 50.5908C90.9186 27.9921 72.5987 9.67226 50 9.67226C27.4013 9.67226 9.08144 27.9921 9.08144 50.5908Z"
                                                fill="currentColor"
                                            />
                                            <path
                                                d="M93.9676 39.0409C96.393 38.4038 97.8624 35.9116 97.0079 33.5539C95.2932 28.8227 92.871 24.3692 89.8167 20.348C85.8452 15.1192 80.8826 10.7238 75.2124 7.41289C69.5422 4.10194 63.2754 1.94025 56.7698 1.05124C51.7666 0.367541 46.6976 0.446843 41.7345 1.27873C39.2613 1.69328 37.813 4.19778 38.4501 6.62326C39.0873 9.04874 41.5694 10.4717 44.0505 10.1071C47.8511 9.54855 51.7191 9.52689 55.5402 10.0491C60.8642 10.7766 65.9928 12.5457 70.6331 15.2552C75.2735 17.9648 79.3347 21.5619 82.5849 25.841C84.9175 28.9121 86.7997 32.2913 88.1811 35.8758C89.083 38.2158 91.5421 39.6781 93.9676 39.0409Z"
                                                fill="currentFill"
                                            />
                                        </svg>
                                        <span className="sr-only">Please wait...</span>
                                    </div>
                                </div>
                            )}
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
};

export default WarehouseReceipts;